<template>
  <div class="min-h-screen bg-slate-50 flex flex-col">
    <template v-if="!isLoading">
      <LoginForm v-if="!authStore.user" />
      
      <template v-else>
        <AppHeader class="mb-1">
          <div class="flex justify-end">
            <div class="flex items-center gap-4">
              <span class="text-sm text-slate-600">
                {{ authStore.user.email }}
              </span>
              <template v-if="authStore.isAdmin()">
                <button 
                  @click="toggleAdminMode"
                  class="text-sm px-3 py-1 rounded-lg"
                  :class="isAdminMode ? 'bg-indigo-100 text-indigo-700' : 'bg-slate-100 text-slate-700'"
                >
                  {{ isAdminMode ? 'Modo Público' : 'Modo Administrador' }}
                </button>
              </template>
              <button 
                @click="authStore.signOut"
                class="text-sm px-3 py-1 rounded-lg bg-red-100 text-red-700"
              >
                Cerrar sesión
              </button>
            </div>
          </div>
        </AppHeader>

        <div class="container mx-auto px-6 flex-grow">
          <AdminLayout v-if="isAdminMode && authStore.isAdmin()" />
          <PublicLayout v-else />
        </div>

        <Footer />
      </template>
    </template>

    <OfflineIndicator />
    <NotificationToast />
    <InstallPrompt />
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import PublicLayout from './layouts/PublicLayout.vue';
import AdminLayout from './layouts/AdminLayout.vue';
import LoginForm from './components/LoginForm.vue';
import OfflineIndicator from './components/OfflineIndicator.vue';
import NotificationToast from './components/NotificationToast.vue';
import InstallPrompt from './components/InstallPrompt.vue';
import AppHeader from './components/AppHeader.vue';
import Footer from './components/Footer.vue';
import { useInitialLoad } from './composables/useInitialLoad';
import { useAuthStore } from './stores/authStore';

const authStore = useAuthStore();
const { isLoading } = useInitialLoad();
const isAdminMode = ref(false);

const toggleAdminMode = () => {
  isAdminMode.value = !isAdminMode.value;
};

onMounted(() => {
  // Remover el preloader inicial cuando la app esté montada
  const preloader = document.getElementById('app-preloader');
  if (preloader) {
    preloader.style.opacity = '0';
    setTimeout(() => {
      preloader.remove();
    }, 300);
  }
});
</script>

<style>
#app-preloader {
  transition: opacity 0.3s ease-out;
}
</style>